import React from 'react'
import classnames from 'classnames'

import IProps, { pixelLayoutCount } from './interface'
import Picture from '../Picture/Picture'

/**
 * Core image component with options for multiple (randomised) pixel
 * corner decorations and a fix collection of image aspect ratios.
 * Additional support for differnt ratios based on screen size
 * to preserve visual heirarchy
 */
const Image = (props: IProps) => {
  const {
    // pixelLayout = random Integer between 1 and 10
    pixelLayout = Math.floor(Math.random() * pixelLayoutCount) + 1,
    usePixelMask,
    caption,
    aspect,
    dataType,
    ...rest // props for the picture element
  } = props

  return (
    <div className='image'>
      <figure
        className={`image__wrapper`}
        {...(dataType ? { 'data-type': dataType } : {})}>
        <Picture
          {...rest}
          classes={{
            picture: classnames({
              ['image__picture']: true,
              [`image__mask--${pixelLayout}`]: usePixelMask,
            }),
            img: classnames({
              ['image__img']: true,
              [`aspect-${aspect?.mobile}`]: aspect?.mobile,
              [`md:aspect-${aspect?.tablet}`]: aspect?.tablet,
              [`lg:aspect-${aspect?.desktop}`]: aspect?.desktop,
            }),
          }}
        />
        {caption?.length ? (
          <figcaption className='image__caption text__sans text--md'>
            {caption}
          </figcaption>
        ) : null}
      </figure>
    </div>
  )
}

export default Image
